import React from 'react';
import PropTypes from 'prop-types';

export const HomeIcon = ({ className }: { className: string }) => (
  <svg height="19px" version="1.1" viewBox="0 0 21 19" width="21px">
    <g transform="translate(0.6999512 0.7000122)">
      <g>
        <path
          className={className}
          d="M0 0L0 6.875L5 6.875L5 1.875C5 1.18464 5.55964 0.625 6.25 0.625L7.5 0.625C8.19036 0.625 8.75 1.18464 8.75 1.875L8.75 6.875L13.75 6.875L13.75 1.4803e-15"
          fill="none"
          id="Path"
          stroke="#494B4E"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.4"
          transform="translate(2.5 10.107239)"
        />
        <path
          className={className}
          d="M0 8.85723L8.49083 0.3664C8.72528 0.131806 9.04334 -3.70074e-16 9.375 0C9.70666 3.70074e-16 10.0247 0.131806 10.2592 0.3664L18.75 8.85723"
          fill="none"
          id="Path"
          stroke="#494B4E"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.4"
        />
      </g>
    </g>
  </svg>
);

export const MessageIcon = ({ className }: { className: string }) => (
  <svg
    height="19px"
    version="1.1"
    viewBox="0 0 19 19"
    width="19px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="icons/messages" transform="translate(0.6999512 0.7000122)">
      <path
        className={className}
        d="M15.8667 13.6L7.93333 13.6L3.4 17L3.4 13.6L1.13333 13.6C0.507411 13.6 1.67767e-16 13.0926 0 12.4667L0 1.13333C-8.38835e-17 0.507411 0.507411 1.67767e-16 1.13333 0L15.8667 0C16.4926 0 17 0.507411 17 1.13333L17 12.4667C17 13.0926 16.4926 13.6 15.8667 13.6Z"
        fill="none"
        id="Path"
        stroke="#494B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <path
        className={className}
        d="M0 0.5L11 0.5"
        fill="none"
        id="Path-2"
        stroke="#494B4E"
        strokeLinecap="round"
        strokeWidth="1.4"
        transform="translate(3 4.3122067)"
      />
      <path
        className={className}
        d="M0 0.5L8 0.5"
        fill="none"
        id="Path-2-Copy"
        stroke="#494B4E"
        strokeLinecap="round"
        strokeWidth="1.4"
        transform="translate(3 7.5)"
      />
    </g>
  </svg>
);

export const MapIcon = ({ className }: { className: string }) => (
  <svg
    height="20px"
    version="1.1"
    viewBox="0 0 20 20"
    width="20px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="icons/map" transform="translate(0.6999512 0.7000122)">
      <path
        className={className}
        d="M16.875 6.18769L16.875 2.92519C16.8751 2.46508 16.595 2.05129 16.1678 1.88044L11.6678 0.0804379C11.3996 -0.0268126 11.1004 -0.0268126 10.8323 0.0804379L6.04276 1.99669C5.77458 2.10394 5.47543 2.10394 5.20726 1.99669L0.771757 0.222188C0.597969 0.152537 0.400917 0.173921 0.246114 0.279229C0.0913115 0.384536 -0.000948587 0.559964 7.35665e-06 0.747188L7.35665e-06 11.5269C-6.94981e-05 11.987 0.280044 12.4008 0.707257 12.5717L5.20726 14.3717C5.47543 14.4789 5.77458 14.4789 6.04276 14.3717L8.20351 13.5069"
        fill="none"
        id="Path"
        stroke="#494B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        transform="translate(0.56249267 0.56231207)"
      />
      <path
        className={className}
        d="M0.375 0L0.375 12.375"
        fill="none"
        id="Path"
        stroke="#494B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        transform="translate(5.8125 2.63925)"
      />
      <path
        className={className}
        d="M0.375 0L0.375 5.625"
        fill="none"
        id="Path"
        stroke="#494B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        transform="translate(11.4375 0.5625)"
      />
      <path
        className={className}
        d="M0.234375 0.234375C0.389705 0.234375 0.515625 0.360295 0.515625 0.515625"
        fill="none"
        id="Path"
        stroke="#494B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        transform="translate(13.828125 11.352375)"
      />
      <path
        className={className}
        d="M0.234375 0.515625C0.234375 0.360295 0.360295 0.234375 0.515625 0.234375"
        fill="none"
        id="Path"
        stroke="#494B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        transform="translate(13.546875 11.352375)"
      />
      <path
        className={className}
        d="M0.515625 0.515625C0.360295 0.515625 0.234375 0.389705 0.234375 0.234375"
        fill="none"
        id="Path"
        stroke="#494B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        transform="translate(13.546875 11.634375)"
      />
      <path
        className={className}
        d="M0.515625 0.234375C0.515625 0.389705 0.389705 0.515625 0.234375 0.515625"
        fill="none"
        id="Path"
        stroke="#494B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        transform="translate(13.828125 11.633625)"
      />
      <path
        className={className}
        d="M3.375 0C5.23896 0 6.75 1.51104 6.75 3.375C6.75 4.81575 4.734 7.557 3.81825 8.7285C3.71165 8.86494 3.54815 8.94468 3.375 8.94468C3.20185 8.94468 3.03835 8.86494 2.93175 8.7285C2.016 7.55775 0 4.81575 0 3.375C-2.66454e-15 1.51104 1.51104 0 3.375 0L3.375 0Z"
        fill="none"
        id="Path"
        stroke="#494B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        transform="translate(10.6875 8.493)"
      />
    </g>
  </svg>
);

export const ShiftIcon = ({
  className,
  width = '19px',
  height = '19px',
  stroke = '#494B4E',
}: {
  className?: string;
  height?: string;
  stroke?: string;
  width?: string;
}) => (
  <svg
    height={height}
    version="1.1"
    viewBox="0 0 19 19"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="icon/shifts" transform="translate(0.7000122 0.7000122)">
      <path
        className={className}
        d="M1.499 0L15.376 0Q15.4496 0 15.5229 0.00721809Q15.5962 0.0144362 15.6684 0.0288029Q15.7407 0.0431695 15.8111 0.0645464Q15.8816 0.0859233 15.9496 0.114105Q16.0177 0.142286 16.0826 0.177Q16.1476 0.211714 16.2088 0.252627Q16.27 0.29354 16.327 0.340257Q16.3839 0.386975 16.436 0.439047Q16.488 0.491119 16.5347 0.548044Q16.5815 0.60497 16.6224 0.6662Q16.6633 0.727431 16.698 0.792376Q16.7327 0.857322 16.7609 0.925357Q16.7891 0.993393 16.8105 1.06386Q16.8318 1.13433 16.8462 1.20656Q16.8606 1.27879 16.8678 1.35207Q16.875 1.42536 16.875 1.499L16.875 13.126Q16.875 13.1996 16.8678 13.2729Q16.8606 13.3462 16.8462 13.4184Q16.8318 13.4907 16.8105 13.5611Q16.7891 13.6316 16.7609 13.6996Q16.7327 13.7677 16.698 13.8326Q16.6633 13.8976 16.6224 13.9588Q16.5815 14.02 16.5347 14.077Q16.488 14.1339 16.436 14.186Q16.3839 14.238 16.327 14.2847Q16.27 14.3315 16.2088 14.3724Q16.1476 14.4133 16.0826 14.448Q16.0177 14.4827 15.9496 14.5109Q15.8816 14.5391 15.8111 14.5605Q15.7407 14.5818 15.6684 14.5962Q15.5962 14.6106 15.5229 14.6178Q15.4496 14.625 15.376 14.625L1.499 14.625Q1.42536 14.625 1.35207 14.6178Q1.27879 14.6106 1.20656 14.5962Q1.13433 14.5818 1.06386 14.5605Q0.993393 14.5391 0.925357 14.5109Q0.857322 14.4827 0.792376 14.448Q0.727431 14.4133 0.6662 14.3724Q0.60497 14.3315 0.548044 14.2847Q0.491119 14.238 0.439047 14.186Q0.386975 14.1339 0.340257 14.077Q0.29354 14.02 0.252627 13.9588Q0.211714 13.8976 0.177 13.8326Q0.142286 13.7677 0.114105 13.6996Q0.0859233 13.6316 0.0645464 13.5611Q0.0431695 13.4907 0.0288029 13.4184Q0.0144362 13.3462 0.00721809 13.2729Q0 13.1996 0 13.126L0 1.499Q0 1.42536 0.00721809 1.35207Q0.0144362 1.27879 0.0288029 1.20656Q0.0431695 1.13433 0.0645464 1.06386Q0.0859233 0.993393 0.114105 0.925357Q0.142286 0.857322 0.177 0.792376Q0.211714 0.727431 0.252627 0.6662Q0.29354 0.60497 0.340257 0.548044Q0.386975 0.491119 0.439047 0.439047Q0.491119 0.386975 0.548044 0.340257Q0.60497 0.29354 0.6662 0.252627Q0.727431 0.211714 0.792376 0.177Q0.857322 0.142286 0.925357 0.114105Q0.993393 0.0859233 1.06386 0.0645464Q1.13433 0.0431695 1.20656 0.0288029Q1.27879 0.0144362 1.35207 0.00721809Q1.42536 0 1.499 0Z"
        fill="none"
        id="Rectangle"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        transform="translate(0 2.25)"
      />
      <path
        className={className}
        d="M0 0.375L16.875 0.375"
        fill="none"
        id="Path"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        transform="translate(0 6.375)"
      />
      <path
        className={className}
        d="M0.375 3.9375L0.375 0"
        fill="none"
        id="Path"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        transform="translate(4.125 0)"
      />
      <path
        className={className}
        d="M0.375 3.9375L0.375 0"
        fill="none"
        id="Path"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        transform="translate(12 0)"
      />
    </g>
  </svg>
);

export const PartnerIcon = ({ className }: { className: string }) => (
  <svg
    height="21px"
    version="1.1"
    viewBox="0 0 16 21"
    width="16px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <desc>Created with Lunacy</desc>
    <g id="icon/partners" transform="translate(0.7000122 0.7000122)">
      <path
        className={className}
        d="M5 0L1.25 0C0.559644 0 0 0.559644 0 1.25L0 15C0 15.6904 0.559644 16.25 1.25 16.25L12.5 16.25C13.1904 16.25 13.75 15.6904 13.75 15L13.75 1.25C13.75 0.559644 13.1904 0 12.5 0L8.75 0"
        fill="none"
        id="Path"
        stroke="#494B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        transform="translate(0 2.5)"
      />
      <path
        className={className}
        d="M3.75 1.875C3.75 0.839466 2.91053 1.85037e-16 1.875 0C0.839466 -9.25186e-17 0 0.839466 0 1.875L0 4.375C0 4.72018 0.279822 5 0.625 5L3.125 5C3.47018 5 3.75 4.72018 3.75 4.375L3.75 1.875Z"
        fill="none"
        id="Path"
        stroke="#494B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        transform="translate(5 0)"
      />
      <path
        className={className}
        d="M2.8125 5.625C4.3658 5.625 5.625 4.3658 5.625 2.8125C5.625 1.2592 4.3658 0 2.8125 0C1.2592 0 0 1.2592 0 2.8125C0 4.3658 1.2592 5.625 2.8125 5.625Z"
        fill="none"
        id="Oval"
        stroke="#494B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        transform="translate(4.0625 7.5)"
      />
      <path
        className={className}
        d="M10 4.37267C9.66331 1.86877 7.52643 0 5 0C2.47357 0 0.336688 1.86877 0 4.37267"
        fill="none"
        id="Path"
        stroke="#494B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        transform="translate(1.875 14.377319)"
      />
    </g>
  </svg>
);

export const PoolIcon = ({ className }: { className: string }) => (
  <svg
    height="19px"
    version="1.1"
    viewBox="0 0 19 19"
    width="19px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <desc>Created with Lunacy</desc>
    <g id="icon/pools" transform="translate(0.7000122 0.7000122)">
      <path
        className={className}
        d="M1.6875 3.375C2.61948 3.375 3.375 2.61948 3.375 1.6875C3.375 0.75552 2.61948 0 1.6875 0C0.75552 0 0 0.75552 0 1.6875C0 2.61948 0.75552 3.375 1.6875 3.375Z"
        fill="none"
        id="Oval"
        stroke="#494B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        transform="translate(1.125 2.25)"
      />
      <path
        className={className}
        d="M2.8125 0C1.2592 0 1.66533e-16 1.2592 0 2.8125L0 4.5L1.125 4.5L1.6875 9L3.9375 9"
        fill="none"
        id="Path"
        stroke="#494B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        transform="translate(0 6.75)"
      />
      <path
        className={className}
        d="M1.6875 3.375C2.61948 3.375 3.375 2.61948 3.375 1.6875C3.375 0.75552 2.61948 0 1.6875 0C0.75552 0 0 0.75552 0 1.6875C0 2.61948 0.75552 3.375 1.6875 3.375Z"
        fill="none"
        id="Oval"
        stroke="#494B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        transform="translate(12.375 2.25)"
      />
      <path
        className={className}
        d="M1.125 0C2.6783 0 3.9375 1.2592 3.9375 2.8125L3.9375 4.5L2.8125 4.5L2.25 9L0 9"
        fill="none"
        id="Path"
        stroke="#494B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        transform="translate(12.9375 6.75)"
      />
      <path
        className={className}
        d="M2.25 4.5C3.49264 4.5 4.5 3.49264 4.5 2.25C4.5 1.00736 3.49264 0 2.25 0C1.00736 0 0 1.00736 0 2.25C0 3.49264 1.00736 4.5 2.25 4.5Z"
        fill="none"
        id="Oval"
        stroke="#494B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        transform="translate(6.1875 0)"
      />
      <path
        className={className}
        d="M7.875 3.9375C7.875 1.76288 6.11212 0 3.9375 0C1.76288 0 0 1.76288 0 3.9375L0 5.625L1.6875 5.625L2.25 11.25L5.625 11.25L6.1875 5.625L7.875 5.625L7.875 3.9375Z"
        fill="none"
        id="Path"
        stroke="#494B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        transform="translate(4.5 5.625)"
      />
    </g>
  </svg>
);

export const PaymentIcon = ({ className }: { className: string }) => (
  <svg
    height="20px"
    version="1.1"
    viewBox="0 0 20 20"
    width="20px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="icon/payments" transform="translate(0.7000122 0.7000122)">
      <path
        className={className}
        d="M8.59091 17.1818C13.3355 17.1818 17.1818 13.3355 17.1818 8.59091C17.1818 3.84628 13.3355 0 8.59091 0C3.84628 0 0 3.84628 0 8.59091C0 13.3355 3.84628 17.1818 8.59091 17.1818Z"
        fill="none"
        id="Oval"
        stroke="#494B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        transform="translate(0.4090909 0.4090909)"
      />
      <path
        className={className}
        d="M4.91341 0.00431844L1.46805 0.00431844C1.07097 -0.027384 0.679957 0.116617 0.398287 0.398287C0.116617 0.679957 -0.027384 1.07097 0.00431844 1.46805C0.00431844 3.0725 4.91341 4.29977 4.91341 5.90423C4.92059 6.29459 4.76868 6.67108 4.4926 6.94715C4.21653 7.22322 3.84004 7.37513 3.44968 7.36795L0.00431844 7.36795"
        fill="none"
        id="Path"
        stroke="#494B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        transform="translate(6.5411363 5.3138633)"
      />
      <path
        className={className}
        d="M0.409091 1.84091L0.409091 0"
        fill="none"
        id="Path"
        stroke="#494B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        transform="translate(8.590909 3.4772727)"
      />
      <path
        className={className}
        d="M0.409091 1.84091L0.409091 0"
        fill="none"
        id="Path"
        stroke="#494B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        transform="translate(8.590909 12.681818)"
      />
    </g>
  </svg>
);

export const TrainingIcon = ({ className }: { className: string }) => (
  <svg
    height="20px"
    version="1.1"
    viewBox="0 0 20 20"
    width="20px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="icon/training" transform="translate(0.6499939 0.6500244)">
      <path
        className={className}
        d="M11.25 1.125C11.25 0.50368 10.7463 0 10.125 0L1.125 0C0.50368 0 8.32667e-17 0.50368 0 1.125L0 15.75C8.32667e-17 16.3713 0.50368 16.875 1.125 16.875L10.125 16.875C10.7463 16.875 11.25 16.3713 11.25 15.75"
        fill="none"
        id="Path"
        stroke="#494B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.3"
        transform="translate(0.5595 0.57825)"
      />
      <path
        className={className}
        d="M1.6875 16.875C0.75552 16.875 0 16.1195 0 15.1875L0 3.9375L1.6875 0L3.375 3.9375L3.375 15.1875C3.375 16.1195 2.61948 16.875 1.6875 16.875L1.6875 16.875Z"
        fill="none"
        id="Path"
        stroke="#494B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.3"
        transform="translate(14.0625 0.57825)"
      />
      <path
        className={className}
        d="M0 0.375L3.375 0.375"
        fill="none"
        id="Path"
        stroke="#494B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.3"
        transform="translate(14.0595 13.70325)"
      />
      <path
        className={className}
        d="M0 0.375L3.375 0.375"
        fill="none"
        id="Path"
        stroke="#494B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.3"
        transform="translate(14.0595 4.14075)"
      />
      <path
        className={className}
        d="M0.375 0L0.375 16.875"
        fill="none"
        id="Path"
        stroke="#494B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.3"
        transform="translate(2.4345 0.57825)"
      />
      <path
        className={className}
        d="M0 0L4.5 0L4.5 3.375L0 3.375L0 0Z"
        fill="none"
        id="Rectangle"
        stroke="#494B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.3"
        transform="translate(5.0595 3.95325)"
      />
    </g>
  </svg>
);

export const AuditIcon = ({ className }: { className: string }) => (
  <svg
    height="20px"
    version="1.1"
    viewBox="0 0 20 20"
    width="20px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="icon/audit" transform="translate(0.7000122 0.7000122)">
      <path
        className={className}
        d="M8.4375 16.875C13.0974 16.875 16.875 13.0974 16.875 8.4375C16.875 3.7776 13.0974 0 8.4375 0C3.7776 0 0 3.7776 0 8.4375C0 13.0974 3.7776 16.875 8.4375 16.875Z"
        fill="none"
        id="Oval"
        stroke="#494B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        transform="translate(0.5625 0.5625)"
      />
      <path
        className={className}
        d="M3.28125 6.5625C5.09343 6.5625 6.5625 5.09343 6.5625 3.28125C6.5625 1.46907 5.09343 0 3.28125 0C1.46907 0 0 1.46907 0 3.28125C0 5.09343 1.46907 6.5625 3.28125 6.5625Z"
        fill="none"
        id="Oval"
        stroke="#494B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        transform="translate(5.0625 5.0625)"
      />
      <path
        className={className}
        d="M0 0L2.27325 2.274"
        fill="none"
        id="Path"
        stroke="#494B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        transform="translate(10.66425 10.6635)"
      />
    </g>
  </svg>
);

export const CallScreeningIcon = ({ className }: { className: string }) => (
  <svg
    height="19px"
    version="1.1"
    viewBox="0 0 19 19"
    width="19px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="icon/phone-screening" transform="translate(0.7000122 0.7000122)">
      <path
        className={className}
        d="M6.25015 9.46224L6.25615 9.46224C7.21311 10.0713 8.46476 9.93383 9.26665 9.13148L9.60565 8.79323C9.92046 8.47814 9.92046 7.96758 9.60565 7.65248L8.18065 6.22749C7.86556 5.91268 7.355 5.91268 7.0399 6.22749L7.0399 6.22749C6.72455 6.54238 6.21375 6.54238 5.8984 6.22749L3.6169 3.94524C3.3021 3.63014 3.3021 3.11958 3.6169 2.80449L3.6169 2.80449C3.93171 2.48939 3.93171 1.97883 3.6169 1.66374L2.1919 0.238735C2.04063 0.0862044 1.83479 0.000282244 1.61996 6.94107e-07C1.40514 -0.000280855 1.19907 0.0851014 1.0474 0.237235L0.708402 0.575485C-0.0932792 1.37806 -0.230432 2.62958 0.378402 3.58674L0.378402 3.59198C1.94256 5.90596 3.93578 7.89866 6.25015 9.46224L6.25015 9.46224Z"
        fill="none"
        id="Path"
        stroke="#494B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        transform="translate(3.7920532 3.2416992)"
      />
      <path
        className={className}
        d="M15.1895 13.502C17.5377 10.3712 17.4252 6.03676 14.9177 3.03208C12.4102 0.0273967 8.16575 -0.858866 4.66537 0.891323C1.165 2.64151 -0.672633 6.56879 0.2266 10.3776C1.12583 14.1865 4.52591 16.8771 8.43945 16.877C11.7529 16.877 13.2739 15.275 12.3507 12.869"
        fill="none"
        id="Path"
        stroke="#494B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const ChevronIconDown = () => (
  <svg
    fill="none"
    height="8"
    viewBox="0 0 13 8"
    width="13"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.7623 1.52772L12.1924 0.98208C12.0574 0.852938 11.8387 0.852938 11.7038 0.98208L6.48915 5.96197L1.27453 0.98208C1.13962 0.852938 0.920881 0.852938 0.785946 0.98208L0.215945 1.52772C0.0810385 1.65686 0.0810385 1.86626 0.215945 1.99543L6.24484 7.76668C6.37975 7.89582 6.59849 7.89582 6.73343 7.76668L12.7623 1.99543C12.8973 1.86626 12.8973 1.65686 12.7623 1.52772Z"
      fill="#A0A3A7"
    />
  </svg>
);

export const ChevronIconDownForDropdown = () => (
  <div
    style={{
      float: 'right',
      // top: '4px',
      left: '12px',

      position: 'relative',
    }}
  >
    <svg
      fill="none"
      height="8"
      viewBox="0 0 13 8"
      width="13"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7623 1.52772L12.1924 0.98208C12.0574 0.852938 11.8387 0.852938 11.7038 0.98208L6.48915 5.96197L1.27453 0.98208C1.13962 0.852938 0.920881 0.852938 0.785946 0.98208L0.215945 1.52772C0.0810385 1.65686 0.0810385 1.86626 0.215945 1.99543L6.24484 7.76668C6.37975 7.89582 6.59849 7.89582 6.73343 7.76668L12.7623 1.99543C12.8973 1.86626 12.8973 1.65686 12.7623 1.52772Z"
        fill="#A0A3A7"
      />
    </svg>
  </div>
);

export const ChevronIconUp = () => (
  <svg
    fill="none"
    height="8"
    viewBox="0 0 13 8"
    width="13"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.7623 6.47228L12.1924 7.01792C12.0574 7.14706 11.8387 7.14706 11.7038 7.01792L6.48915 2.03803L1.27453 7.01792C1.13962 7.14706 0.920881 7.14706 0.785946 7.01792L0.215945 6.47228C0.0810385 6.34314 0.0810385 6.13374 0.215945 6.00457L6.24484 0.233322C6.37975 0.10418 6.59849 0.10418 6.73343 0.233322L12.7623 6.00457C12.8973 6.13374 12.8973 6.34314 12.7623 6.47228Z"
      fill="#A0A3A7"
    />
  </svg>
);

export const Star = () => (
  <svg
    fill="none"
    height="18.75"
    viewBox="0 0 22 22"
    width="18.75"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M11.6076 2.00012L14.3959 7.52428L19.7626 8.05595C20.0235 8.07763 20.2479 8.24908 20.3374 8.49508C20.427 8.74108 20.3652 9.01667 20.1793 9.20095L15.7626 13.5784L17.4001 19.5268C17.4685 19.7845 17.3794 20.0584 17.1725 20.2265C16.9655 20.3946 16.6792 20.4257 16.4409 20.3059L11.0001 17.6118L5.56676 20.3026C5.32854 20.4224 5.0422 20.3913 4.83523 20.2232C4.62826 20.0551 4.53916 19.7812 4.6076 19.5234L6.2451 13.5751L1.8251 9.19762C1.63916 9.01334 1.57741 8.73774 1.66693 8.49174C1.75645 8.24575 1.98088 8.07429 2.24176 8.05262L7.60843 7.52095L10.3926 2.00012C10.5093 1.7721 10.7439 1.62866 11.0001 1.62866C11.2563 1.62866 11.4909 1.7721 11.6076 2.00012Z"
      fillRule="evenodd"
      stroke="#0071D5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export const Bookmark = ({ size = '18.75' }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 20 20"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M10.9667 19.1275L1.15166 9.48662C0.63836 8.93559 0.339212 8.21905 0.308324 7.46662L0.30249 2.05412C0.30249 1.13364 1.04868 0.387451 1.96916 0.387451H7.37916C8.11919 0.41532 8.8253 0.705027 9.37166 1.20495C9.38721 1.21886 9.40114 1.23358 9.41585 1.2491L9.41666 1.24995L19.1983 10.87C19.5154 11.1816 19.6949 11.607 19.6967 12.0516C19.6986 12.4962 19.5228 12.9231 19.2083 13.2375L13.3208 19.1233C12.6767 19.7678 11.6345 19.7756 10.9808 19.1408L10.9667 19.1275ZM5.30249 4.13745C4.61213 4.13745 4.05249 4.6971 4.05249 5.38745C4.05249 6.07781 4.61213 6.63745 5.30249 6.63745C5.99285 6.63745 6.55249 6.07781 6.55249 5.38745C6.55249 4.6971 5.99285 4.13745 5.30249 4.13745Z"
      fill="#0071D5"
      fillRule="evenodd"
    />
  </svg>
);

export const Message = ({ size = '18.75' }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 20 19"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0001 0.280762C4.71591 0.280762 0.416748 3.82243 0.416748 8.17576C0.449731 10.2942 1.41839 12.2895 3.06258 13.6258L1.14591 17.4483C1.06633 17.6069 1.09597 17.7986 1.21977 17.9257C1.34357 18.0529 1.53435 18.0877 1.69508 18.0124L6.81925 15.6274C7.85334 15.9244 8.92418 16.074 10.0001 16.0716C15.2842 16.0716 19.5834 12.5299 19.5834 8.17576C19.5834 3.8216 15.2842 0.280762 10.0001 0.280762Z"
      fill="#0071D5"
    />
  </svg>
);

export const CalenderPencil = ({ size = '18.75' }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 22 22"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.2 14.52C1.95699 14.52 1.76 14.323 1.76 14.08V6.6C1.76 6.35699 1.95699 6.16 2.2 6.16H14.08C14.323 6.16 14.52 6.35699 14.52 6.6V10.8029C14.5202 10.8918 14.5739 10.9719 14.6562 11.0058C14.7384 11.0397 14.8329 11.0207 14.8958 10.9578L16.2158 9.63776C16.2572 9.59684 16.2806 9.54111 16.2809 9.48288V2.64C16.2809 2.15399 15.8869 1.76 15.4009 1.76H13.2C13.0785 1.76 12.98 1.6615 12.98 1.54V0.66C12.98 0.295492 12.6845 0 12.32 0C11.9555 0 11.66 0.295492 11.66 0.66V3.96C11.66 4.32451 11.3645 4.62 11 4.62C10.6355 4.62 10.34 4.32451 10.34 3.96V2.2C10.34 1.95699 10.143 1.76 9.9 1.76H6.16C6.0385 1.76 5.94 1.6615 5.94 1.54V0.66C5.94 0.295492 5.64451 0 5.28 0C4.91549 0 4.62 0.295492 4.62 0.66V3.96C4.62 4.32451 4.32451 4.62 3.96 4.62C3.59549 4.62 3.3 4.32451 3.3 3.96V2.2C3.3 1.95699 3.10301 1.76 2.86 1.76H0.88C0.393989 1.76 0 2.15399 0 2.64V14.52C0 15.492 0.787979 16.28 1.76 16.28H9.482C9.54037 16.28 9.59637 16.2569 9.63776 16.2158L10.9578 14.8958C11.0208 14.8328 11.0397 14.7381 11.0056 14.6558C10.9715 14.5734 10.8911 14.5198 10.802 14.52H2.2Z"
      fill="#0071D5"
    />
    <path
      d="M10.2424 21.1042L12.9704 20.3245C13.1203 20.2818 13.2364 20.163 13.2757 20.0121C13.3149 19.8613 13.2714 19.7009 13.1613 19.5906L11.2121 17.6414C11.1019 17.5313 10.9417 17.4877 10.7909 17.5268C10.6401 17.5658 10.5211 17.6817 10.4782 17.8315L9.69854 20.5595C9.65471 20.7131 9.69757 20.8784 9.81052 20.9913C9.92348 21.1043 10.0888 21.1471 10.2424 21.1033V21.1042Z"
      fill="#0071D5"
    />
    <path
      d="M11.5303 16.7161C11.335 16.5208 11.3351 16.2043 11.5303 16.009L15.8548 11.6846C16.0501 11.4894 16.3667 11.4894 16.5619 11.6847L19.1166 14.2394C19.3119 14.4347 19.3119 14.7513 19.1166 14.9466L14.7921 19.2709C14.5969 19.4662 14.2803 19.4662 14.085 19.2709L11.5303 16.7161Z"
      fill="#0071D5"
    />
    <path
      d="M20.446 13.619C21.0414 13.0327 21.2733 12.1704 21.0523 11.3646C20.8313 10.5588 20.1919 9.93546 19.3808 9.73496C18.5696 9.53445 17.7135 9.78814 17.1425 10.3982C16.9707 10.57 16.9707 10.8485 17.1425 11.0203L19.7825 13.6603C19.9816 13.8186 20.2681 13.8007 20.446 13.619Z"
      fill="#0071D5"
    />
  </svg>
);

export const Close = ({ size = '18.75' }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 17 16"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.4375 14.562L15.5625 1.43701"
      stroke="#54565A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M14.5625 14.562L1.4375 1.43701"
      stroke="#54565A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export const Phone = ({ size = '18.75' }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 20 20"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.8941 14.1741L16.8508 12.13C16.4113 11.6897 15.8148 11.4423 15.1928 11.4423C14.5708 11.4423 13.9743 11.6897 13.5349 12.13L13.1183 12.5466C11.0647 10.826 9.16783 8.92661 7.44992 6.87078L7.86658 6.45412C8.7801 5.53792 8.7801 4.05531 7.86658 3.13912L5.81908 1.09745C4.89051 0.210355 3.42849 0.210355 2.49992 1.09745L1.38325 2.21912C0.277271 3.33306 0.1034 5.06969 0.966585 6.38078C4.29583 11.3973 8.59489 15.6972 13.6108 19.0275C14.9256 19.8823 16.6578 19.709 17.7774 18.6108L18.8983 17.4891C19.3384 17.05 19.5857 16.4538 19.5857 15.832C19.5857 15.2103 19.3384 14.6141 18.8983 14.175L18.8941 14.1741Z"
      fill="#0071D5"
    />
  </svg>
);

export const Email = ({ size = '18.75' }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 22 15"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.1879 9.67633C10.6358 10.1229 11.3606 10.1229 11.8085 9.67633L20.6874 0.797501C20.8103 0.675004 20.8535 0.49357 20.799 0.328805C20.7445 0.164041 20.6015 0.0442112 20.4298 0.0192513C20.3427 0.00641668 20.2548 -1.72211e-05 20.1667 1.34838e-06H1.83337C1.74471 -0.000107106 1.65617 0.00632703 1.56846 0.0192513C1.39671 0.0442112 1.25378 0.164041 1.19925 0.328805C1.14472 0.49357 1.18793 0.675004 1.31087 0.797501L10.1879 9.67633Z"
      fill="#0071D5"
    />
    <path
      d="M21.8973 1.67929C21.8347 1.65268 21.7621 1.66683 21.714 1.71504L16.0307 7.39838C15.9414 7.48813 15.9414 7.63312 16.0307 7.72288L20.6534 12.3456C20.8322 12.5182 20.904 12.7737 20.8412 13.0141C20.7784 13.2545 20.5908 13.4423 20.3504 13.5054C20.1101 13.5684 19.8544 13.4968 19.6817 13.3182L15.059 8.69546C15.016 8.65236 14.9576 8.62813 14.8968 8.62813C14.8359 8.62813 14.7775 8.65236 14.7345 8.69546L12.7829 10.647C11.7986 11.6308 10.2032 11.6308 9.21892 10.647L7.2655 8.69729C7.17575 8.60803 7.03075 8.60803 6.941 8.69729L2.31825 13.32C2.04837 13.5805 1.61957 13.5765 1.3545 13.3112C1.08943 13.0459 1.08591 12.6171 1.34658 12.3475L5.96933 7.72471C6.0586 7.63496 6.0586 7.48996 5.96933 7.40021L0.286 1.71688C0.238166 1.66819 0.16529 1.65398 0.102667 1.68113C0.0411081 1.70677 0.000734505 1.76661 0 1.83329V12.8333C0 13.8458 0.820811 14.6666 1.83333 14.6666H20.1667C21.1792 14.6666 22 13.8458 22 12.8333V1.83329C22.0002 1.76587 21.9597 1.705 21.8973 1.67929Z"
      fill="#0071D5"
    />
  </svg>
);

export const Triangle = () => (
  <svg
    fill="none"
    height="6"
    viewBox="0 0 12 6"
    width="12"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M6 0L0 6L12 6L6 0Z"
      fill="#404040"
      fillRule="evenodd"
    />
  </svg>
);

export const StarIconPartner = () => (
  <svg
    fill="none"
    height="14"
    viewBox="0 0 13 14"
    width="13"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M6.3645 1.59983L8.0375 4.91433L11.2575 5.23333C11.414 5.24633 11.5487 5.3492 11.6024 5.4968C11.6561 5.6444 11.6191 5.80976 11.5075 5.92033L8.8575 8.54682L9.84 12.1158C9.88106 12.2705 9.8276 12.4348 9.70342 12.5357C9.57924 12.6365 9.40744 12.6552 9.2645 12.5833L6 10.9668L2.74 12.5813C2.59706 12.6532 2.42526 12.6345 2.30108 12.5337C2.1769 12.4328 2.12344 12.2685 2.1645 12.1138L3.147 8.54483L0.494999 5.91832C0.383439 5.80776 0.346386 5.6424 0.400097 5.4948C0.453808 5.3472 0.588471 5.24433 0.744999 5.23133L3.965 4.91233L5.6355 1.59983C5.70555 1.46302 5.8463 1.37695 6 1.37695C6.1537 1.37695 6.29445 1.46302 6.3645 1.59983Z"
      fill="#32A623"
      fillRule="evenodd"
      stroke="#32A623"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export const ClockIconPartner = ({ color = '#E35C5C' }: { color: string }) => (
  <svg
    fill="none"
    height="12"
    viewBox="0 0 12 12"
    width="12"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M0 6C0 2.68629 2.68629 0 6 0C9.31222 0.00358242 11.9964 2.68778 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6ZM7.8935 8.6415C8.09872 8.82369 8.41153 8.80996 8.6 8.6105V8.611C8.6895 8.51293 8.73631 8.38328 8.73012 8.25066C8.72393 8.11803 8.66524 7.99331 8.567 7.904L6.25 5.78V3.25C6.25 2.97386 6.02614 2.75 5.75 2.75C5.47386 2.75 5.25 2.97386 5.25 3.25V6C5.2505 6.14041 5.31002 6.27414 5.414 6.3685L7.8935 8.6415Z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

export const GraphStatsDescend = () => (
  <svg
    fill="none"
    height="8"
    viewBox="0 0 13 8"
    width="13"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.625 3.625V7H9.25"
      stroke="#E35C5C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.2"
    />
    <path
      d="M12.625 7L8.6555 3.0305C8.51483 2.88974 8.324 2.81066 8.125 2.81066C7.926 2.81066 7.73517 2.88974 7.5945 3.0305L6.0305 4.5945C5.88983 4.73526 5.699 4.81434 5.5 4.81434C5.301 4.81434 5.11017 4.73526 4.9695 4.5945L1.375 1"
      stroke="#E35C5C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.2"
    />
  </svg>
);

export const GraphStatsAscend = () => (
  <svg
    fill="none"
    height="8"
    viewBox="0 0 14 8"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.625 4.375V1H9.25"
      stroke="#32A623"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.2"
    />
    <path
      d="M12.625 1L8.6555 4.9695C8.51483 5.11026 8.324 5.18934 8.125 5.18934C7.926 5.18934 7.73517 5.11026 7.5945 4.9695L6.0305 3.4055C5.88983 3.26474 5.699 3.18566 5.5 3.18566C5.301 3.18566 5.11017 3.26474 4.9695 3.4055L1.375 7"
      stroke="#32A623"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.2"
    />
  </svg>
);

export const ChevronIconDownForMetrics = () => (
  <svg
    fill="none"
    height="7"
    viewBox="0 0 13 7"
    width="22"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.882 0.65324L12.312 0.107598C12.1771 -0.0215432 11.9583 -0.0215432 11.8234 0.107598L6.60878 5.08749L1.39416 0.107598C1.25925 -0.0215432 1.04051 -0.0215432 0.905575 0.107598L0.335574 0.65324C0.200667 0.782382 0.200667 0.991776 0.335574 1.12094L6.36447 6.8922C6.49938 7.02134 6.71812 7.02134 6.85306 6.8922L12.882 1.12094C13.0169 0.991776 13.0169 0.782382 12.882 0.65324Z"
      fill="#2C2D30"
    />
  </svg>
);

export const BackArrow = () => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.25 12.497H0.75"
      stroke="#494B4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M4.5 16.247L0.75 12.497L4.5 8.74701"
      stroke="#494B4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export const InvoiceIcon = () => (
  <svg
    fill="none"
    height="15"
    viewBox="0 0 14 18"
    width="15"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.375 1.28011C13.375 1.1318 13.331 0.986827 13.2486 0.863519C13.1661 0.740212 13.049 0.644107 12.912 0.587355C12.775 0.530602 12.6242 0.51575 12.4787 0.544676C12.3333 0.573601 12.1996 0.645006 12.0947 0.749863L11.6327 1.21186C11.5974 1.24676 11.5497 1.26633 11.5 1.26633C11.4503 1.26633 11.4026 1.24676 11.3673 1.21186L10.5303 0.374863C10.3896 0.23426 10.1989 0.155273 10 0.155273C9.80113 0.155273 9.6104 0.23426 9.46975 0.374863L8.63275 1.21186C8.59738 1.24676 8.54969 1.26633 8.5 1.26633C8.45031 1.26633 8.40262 1.24676 8.36725 1.21186L7.53025 0.374863C7.3896 0.23426 7.19887 0.155273 7 0.155273C6.80113 0.155273 6.6104 0.23426 6.46975 0.374863L5.63275 1.21186C5.59738 1.24676 5.54969 1.26633 5.5 1.26633C5.45031 1.26633 5.40262 1.24676 5.36725 1.21186L4.53025 0.374863C4.3896 0.23426 4.19887 0.155273 4 0.155273C3.80113 0.155273 3.6104 0.23426 3.46975 0.374863L2.63275 1.21186C2.59738 1.24676 2.54969 1.26633 2.5 1.26633C2.45031 1.26633 2.40262 1.24676 2.36725 1.21186L1.90525 0.749863C1.80036 0.645006 1.66674 0.573601 1.52127 0.544676C1.37581 0.51575 1.22503 0.530602 1.08801 0.587355C0.950984 0.644107 0.833862 0.740212 0.751449 0.863519C0.669036 0.986827 0.625032 1.1318 0.625 1.28011V16.7196C0.625032 16.8679 0.669036 17.0129 0.751449 17.1362C0.833862 17.2595 0.950984 17.3556 1.08801 17.4124C1.22503 17.4691 1.37581 17.484 1.52127 17.4551C1.66674 17.4261 1.80036 17.3547 1.90525 17.2499L2.36725 16.7871C2.40262 16.7522 2.45031 16.7326 2.5 16.7326C2.54969 16.7326 2.59738 16.7522 2.63275 16.7871L3.46975 17.6249C3.6104 17.7655 3.80113 17.8445 4 17.8445C4.19887 17.8445 4.3896 17.7655 4.53025 17.6249L5.36725 16.7871C5.40262 16.7522 5.45031 16.7326 5.5 16.7326C5.54969 16.7326 5.59738 16.7522 5.63275 16.7871L6.46975 17.6249C6.6104 17.7655 6.80113 17.8445 7 17.8445C7.19887 17.8445 7.3896 17.7655 7.53025 17.6249L8.36725 16.7871C8.40262 16.7522 8.45031 16.7326 8.5 16.7326C8.54969 16.7326 8.59738 16.7522 8.63275 16.7871L9.46975 17.6249C9.6104 17.7655 9.80113 17.8445 10 17.8445C10.1989 17.8445 10.3896 17.7655 10.5303 17.6249L11.3673 16.7879C11.3846 16.7703 11.4053 16.7564 11.4281 16.7469C11.4509 16.7374 11.4753 16.7325 11.5 16.7325C11.5247 16.7325 11.5491 16.7374 11.5719 16.7469C11.5947 16.7564 11.6154 16.7703 11.6327 16.7879L12.094 17.2499C12.1988 17.355 12.3325 17.4266 12.4781 17.4557C12.6237 17.4848 12.7747 17.47 12.9118 17.4132C13.049 17.3564 13.1663 17.2602 13.2487 17.1367C13.3312 17.0132 13.3751 16.8681 13.375 16.7196V1.28011ZM8.07325 12.3576C8.03351 12.2954 8.00641 12.226 7.99349 12.1533C7.98058 12.0807 7.9821 12.0062 7.99798 11.9341C8.01386 11.862 8.04378 11.7937 8.08604 11.7332C8.12829 11.6727 8.18205 11.6211 8.24425 11.5814C8.30645 11.5416 8.37586 11.5145 8.44853 11.5016C8.52121 11.4887 8.59571 11.4902 8.66779 11.5061C8.73987 11.522 8.80812 11.5519 8.86864 11.5942C8.92916 11.6364 8.98076 11.6902 9.0205 11.7524C9.1078 11.8899 9.22941 12.0022 9.37336 12.0784C9.51731 12.1546 9.67862 12.192 9.84141 12.1869C10.0042 12.1818 10.1628 12.1343 10.3017 12.0493C10.4406 11.9642 10.5549 11.8444 10.6334 11.7017C10.7119 11.559 10.7519 11.3983 10.7493 11.2354C10.7468 11.0726 10.7019 10.9132 10.6191 10.7729C10.5362 10.6327 10.4183 10.5165 10.2768 10.4357C10.1354 10.355 9.97537 10.3125 9.8125 10.3124C9.28568 10.3114 8.77922 10.1088 8.397 9.74623C8.01479 9.38366 7.78581 8.88858 7.75703 8.36255C7.72824 7.83651 7.90185 7.31941 8.24222 6.9173C8.58259 6.5152 9.06394 6.25859 9.5875 6.20011C9.63331 6.19512 9.67566 6.17336 9.70639 6.13902C9.73713 6.10469 9.75409 6.0602 9.754 6.01411V5.75011C9.754 5.60093 9.81326 5.45786 9.91875 5.35237C10.0242 5.24688 10.1673 5.18761 10.3165 5.18761C10.4657 5.18761 10.6088 5.24688 10.7142 5.35237C10.8197 5.45786 10.879 5.60093 10.879 5.75011V6.37486C10.8792 6.40567 10.8868 6.43597 10.9013 6.46315C10.9158 6.49033 10.9368 6.51357 10.9623 6.53086C11.2074 6.69536 11.4146 6.91043 11.5697 7.16161C11.6087 7.22445 11.6348 7.29434 11.6467 7.36728C11.6586 7.44022 11.656 7.51479 11.6391 7.58673C11.6222 7.65868 11.5912 7.72658 11.5481 7.78657C11.5049 7.84656 11.4503 7.89746 11.3875 7.93636C11.3247 7.97527 11.2548 8.00141 11.1818 8.01331C11.1089 8.02521 11.0343 8.02262 10.9624 8.00569C10.8904 7.98877 10.8225 7.95784 10.7625 7.91468C10.7026 7.87151 10.6517 7.81695 10.6127 7.75411C10.5265 7.61574 10.4057 7.50224 10.2622 7.42482C10.1188 7.3474 9.95756 7.30873 9.79457 7.31264C9.63158 7.31655 9.47243 7.3629 9.33282 7.44711C9.19322 7.53133 9.07799 7.65049 8.99851 7.79284C8.91902 7.93519 8.87804 8.09581 8.8796 8.25884C8.88116 8.42187 8.92521 8.58167 9.0074 8.72248C9.08959 8.86329 9.20707 8.98022 9.34826 9.06175C9.48945 9.14327 9.64946 9.18657 9.8125 9.18736C10.3403 9.18662 10.8483 9.38833 11.2318 9.75094C11.6154 10.1135 11.8452 10.6094 11.8741 11.1365C11.9029 11.6635 11.7285 12.1815 11.3869 12.5838C11.0452 12.9861 10.5622 13.242 10.0375 13.2989C9.99156 13.3039 9.94911 13.3257 9.91835 13.3602C9.8876 13.3947 9.87073 13.4394 9.871 13.4856V13.7504C9.871 13.8995 9.81174 14.0426 9.70625 14.1481C9.60076 14.2536 9.45768 14.3129 9.3085 14.3129C9.15932 14.3129 9.01624 14.2536 8.91075 14.1481C8.80526 14.0426 8.746 13.8995 8.746 13.7504V13.1249C8.74603 13.094 8.73844 13.0636 8.72392 13.0364C8.7094 13.0092 8.68839 12.986 8.66275 12.9689C8.42586 12.8083 8.22508 12.6002 8.07325 12.3576ZM5.875 10.3124H3.25C3.10082 10.3124 2.95774 10.2531 2.85225 10.1476C2.74676 10.0421 2.6875 9.89905 2.6875 9.74986C2.6875 9.60068 2.74676 9.45761 2.85225 9.35212C2.95774 9.24663 3.10082 9.18736 3.25 9.18736H5.875C6.02418 9.18736 6.16726 9.24663 6.27275 9.35212C6.37824 9.45761 6.4375 9.60068 6.4375 9.74986C6.4375 9.89905 6.37824 10.0421 6.27275 10.1476C6.16726 10.2531 6.02418 10.3124 5.875 10.3124ZM6.0625 12.7499C6.0625 12.899 6.00324 13.0421 5.89775 13.1476C5.79226 13.2531 5.64918 13.3124 5.5 13.3124H3.25C3.10082 13.3124 2.95774 13.2531 2.85225 13.1476C2.74676 13.0421 2.6875 12.899 2.6875 12.7499C2.6875 12.6007 2.74676 12.4576 2.85225 12.3521C2.95774 12.2466 3.10082 12.1874 3.25 12.1874H5.5C5.64918 12.1874 5.79226 12.2466 5.89775 12.3521C6.00324 12.4576 6.0625 12.6007 6.0625 12.7499ZM5.875 7.31236H3.25C3.10082 7.31236 2.95774 7.2531 2.85225 7.14761C2.74676 7.04212 2.6875 6.89905 2.6875 6.74986C2.6875 6.60068 2.74676 6.45761 2.85225 6.35212C2.95774 6.24663 3.10082 6.18736 3.25 6.18736H5.875C6.02418 6.18736 6.16726 6.24663 6.27275 6.35212C6.37824 6.45761 6.4375 6.60068 6.4375 6.74986C6.4375 6.89905 6.37824 7.04212 6.27275 7.14761C6.16726 7.2531 6.02418 7.31236 5.875 7.31236Z"
      fill="#0071D5"
    />
  </svg>
);

export const GoogleIcon: React.FC<{ height?: number; width?: number }> = ({
  width,
  height,
}) => (
  <svg
    height={height}
    viewBox="0 0 48 48"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        d="M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z"
        id="a"
      />
    </defs>
    <clipPath id="b">
      <use overflow="visible" xlinkHref="#a" />
    </clipPath>
    <path clipPath="url(#b)" d="M0 37V11l17 13z" fill="#FBBC05" />
    <path clipPath="url(#b)" d="M0 11l17 13 7-6.1L48 14V0H0z" fill="#EA4335" />
    <path clipPath="url(#b)" d="M0 37l30-23 7.9 1L48 0v48H0z" fill="#34A853" />
    <path clipPath="url(#b)" d="M48 48L17 24l-4-3 35-10z" fill="#4285F4" />
  </svg>
);

export const customIcons = {
  AuditIcon,
  BackArrow,
  Bookmark,
  CalenderPencil,
  CallScreeningIcon,
  ChevronIconDown,
  ChevronIconDownForDropdown,
  ChevronIconDownForMetrics,
  ChevronIconUp,
  ClockIconPartner,
  Close,
  Email,
  GoogleIcon,
  GraphStatsAscend,
  GraphStatsDescend,
  HomeIcon,
  InvoiceIcon,
  MapIcon,
  Message,
  MessageIcon,
  PartnerIcon,
  PaymentIcon,
  Phone,
  PoolIcon,
  ShiftIcon,
  Star,
  StarIconPartner,
  TrainingIcon,
  Triangle,
};

export default customIcons;
